import { render } from "./ListInline.vue?vue&type=template&id=9bfa2aac"
import script from "./ListInline.vue?vue&type=script&lang=js"
export * from "./ListInline.vue?vue&type=script&lang=js"
script.render = render

export default script